import { restGet, restPost } from "./restClient.js";

export function uuidToProtoBytes(uuid) {
    const hex = String(uuid || "").replaceAll("-", "");
    if (!/^[0-9a-fA-F]{32}$/.test(hex)) throw new Error("A valid UUID is required");
    const bytes = new Uint8Array(16);
    for (let index = 0; index < bytes.length; index += 1) {
        bytes[index] = Number.parseInt(hex.slice(index * 2, index * 2 + 2), 16);
    }
    let binary = "";
    for (const byte of bytes) binary += String.fromCharCode(byte);
    return btoa(binary);
}

export function protoBytesToUuid(value) {
    if (!value) return "";
    const binary = atob(value);
    if (binary.length !== 16) return "";
    const hex = Array.from(binary, (character) =>
        character.charCodeAt(0).toString(16).padStart(2, "0"),
    ).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export const ARTIFACT_ROLLOUT_PAGE_SIZE = 200;

export async function listArtifactRollouts({ componentId, pageToken } = {}) {
    const query = { "filter.page_size": ARTIFACT_ROLLOUT_PAGE_SIZE };
    if (componentId) query["filter.component_id"] = componentId;
    if (pageToken) query["filter.page_token"] = pageToken;
    return restGet("/v1/artifact-rollouts", query);
}

export async function applyArtifactRolloutCommand(commandName, value) {
    return restPost("/v1/artifact-rollouts:apply", {
        command: {
            idempotencyKey: crypto.randomUUID(),
            [commandName]: value,
        },
    });
}

/** Read rollout timing under the endpoint's metadata permissions. */
export async function getEndpointUpdateRollout(endpointId) {
    return restPost("/v1/endpoints/update-rollout:get", {
        endpointId: uuidToProtoBytes(endpointId),
    });
}
